import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { SelectItem } from '../../../shared/interfaces/select-item.interface';
import { Subscription } from 'rxjs';
import { HttpService } from '../../../services/http.service';
import { EditUploadsService } from '../../../uploads/edit-uploads.service';
import { HttpClient } from '@angular/common/http';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-upload-mt103',
  templateUrl: './upload-mt103.component.html',
  styleUrls: ['./upload-mt103.component.scss'],
})
export class UploadMt103Component implements OnDestroy {
  roles: SelectItem[] = [];
  multiple: boolean;
  show: boolean;
  private subscriptions = new Subscription();
  showUploadLoader = false;
  showValidateLoader = false;
  @ViewChild('fileUploader') fileUploader!: ElementRef;
  constructor(
    private http: HttpService,
    public editUploadsService: EditUploadsService,
    private apiClient: HttpClient,
  ) {}

  downloadTemplate() {
    const filename = 'mt103_template.txt';
    const apiUrl = 'assets/resources/mt_103_template.txt';

    this.apiClient.get(apiUrl, { responseType: 'arraybuffer' }).subscribe((data: ArrayBuffer) => {
      const blob = new Blob([data], { type: 'text/txt' });
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = filename;

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    });
  }

  fileChangeValidate(element: any) {
    this.showValidateLoader = true;
    this.http.validateFile(element.target.files[0]).subscribe(
      (event: any) => {
        this.showValidateLoader = false;
        Swal.fire({
          icon: 'success',
          text: 'File successfully validated.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
        element.target.files = null;
        this.resetFileUploader();
      },
      (error) => {
        this.showValidateLoader = false;
        let errorMessage = error;
        if (Array.isArray(error)) {
          errorMessage = this.generateStringFromArrayWithLineBreak(error);
        }
        Swal.fire({
          title: 'Error',
          icon: 'error',
          html: '<div class="poprow"> ' + errorMessage + '</div>',
          showConfirmButton: true,
          confirmButtonText: 'Close',
        }).then();
        this.resetFileUploader();
      },
    );
  }

  fileChange(element: any) {
    this.showUploadLoader = true;
    const file = element.target.files[0];
    if (!file) {
      this.showUploadLoader = false;
      return;
    }

    this.http.uploadMT103File(file).subscribe(
      (event: any) => {
        this.showUploadLoader = false;
        Swal.fire({
          icon: 'success',
          text: 'File successfully uploaded.',
          showConfirmButton: true,
          confirmButtonText: 'Ok',
        });
        element.target.value = '';
      },
      (error) => {
        this.showUploadLoader = false;
        let errorMessage = error;
        if (Array.isArray(error)) {
          errorMessage = this.generateStringFromArrayWithLineBreak(error);
        }
        Swal.fire({
          title: 'Error',
          icon: 'error',
          html: `<div class="poprow">${errorMessage}</div>`,
          showConfirmButton: true,
          confirmButtonText: 'Close',
        });
        element.target.value = '';
      },
    );
  }

  generateStringFromArrayWithLineBreak(array: string[]): string {
    let result = '';
    array.forEach((item, index) => {
      result += item;
      if (index < array.length - 1) {
        result += '<hr></br>';
      }
    });
    return result;
  }

  resetFileUploader() {
    this.fileUploader.nativeElement.value = null;
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
}

